import { isUwp } from './isUwp';
export function isWebView2() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chrome = window.chrome;
    return chrome && chrome.webview && isUwp();
}
//# sourceMappingURL=isWebView2.js.map